import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Routes } from '@angular/router';

const chargeCatRoutes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(chargeCatRoutes)],
  exports: [RouterModule]
})
export class ChargeCatRoutingModule {}
